import ZoneManagerMomentAttendance from '../../features/zoneManager/ZoneManagerMomentAttendance'

const ZoneManagerMomentAttendancePage = () => {
  return <ZoneManagerMomentAttendance/>
}

export default ZoneManagerMomentAttendancePage